import axios from "axios";
import {baseUrl, getWithAuth} from "./baseApi";

export type LoginRequest = {login : string, password: string};
export type ForgotPasswordRequest = {email : string};
export type LoginResponse = {
     token : string, 
     result: 'success' | 'fail',
     name: string,
     permission: Permission[],
     profilePicture: string,
    };
type ValidateTokenResponse = { Result : string };



export const login = async (request : LoginRequest) => {
    try{
        var result = await axios({method: "POST", data: request, url: `${baseUrl}auth/login`});
        return { result : 'success', token : result.data.token, name: result.data.name, permissions: result.data.permissions, profilePicture: result.data.profilePicture }
    }
    catch(err : any){
        return {result : 'fail'}
    }    
}

export const getToken = () => {
    let token = window.localStorage.getItem("auth");
    if(!!!token || token == ""){
        token = window.sessionStorage.getItem("auth");
    }

    return token;
}

export const removeToken = () => {
    window.localStorage.removeItem("auth");
    window.sessionStorage.removeItem("auth");
}

export const validateToken = async () : Promise<"unathorized" | "unhadledError" | "athorized"> => {
    var result = await getWithAuth<ValidateTokenResponse>({url : `${baseUrl}auth/validate`});
    switch(result.type){
        case "unathorized": return "unathorized";
        case "unhadledError" : return "unhadledError";
        case "succes": return "athorized";
    }
}

export const setToken = async (token: string, sessionType: "persistent" | "session") => {
    if(sessionType == "persistent"){
        window.localStorage.setItem('auth', token);
    }
    if(sessionType == "session"){
        window.sessionStorage.setItem("auth", token);
    }
}


export enum Permission {
    Users = 1,
    Dashboard = 2,
    Campaigns = 3,
    Channels = 4,
    Media = 5,
    Players = 6,
    Reports = 7,
    PriorityList = 8,
    PlayNowList = 9,
    MosaicScreen = 10,
    Settings = 11,
    Monitoring = 12,
    ExternalOrganisationUser = 1000,
}

export type UserData = {
    name: string,
    permissions: Permission[],
    profilePicture: string
}

export type PasswordRecoverData = {
    email: string,
}

export const setUserData = async (userData: UserData, sessionType: "persistent" | "session") => {
    if(sessionType == "persistent"){
        window.localStorage.setItem('userData', JSON.stringify(userData));
    }
    if(sessionType == "session"){
        window.sessionStorage.setItem("userData", JSON.stringify(userData));
    }
}

export const updateUserName = (userName: string) => {
    let userDataJson = window.localStorage.getItem("userData");
    if(!!userDataJson){
        let jsonData: UserData = JSON.parse(userDataJson);
        jsonData.name = userName;
        setUserData(jsonData, "persistent");
        return;
    }
    userDataJson = window.sessionStorage.getItem("userData");
    if(!!userDataJson){
        let jsonData: UserData = JSON.parse(userDataJson);   
        jsonData.name = userName;
        setUserData(jsonData, "session");
        return;     
    }
} 

export const setNewProfilePicture = (profilePicture: string) => {
    let userDataJson = window.localStorage.getItem("userData");
    if(!!userDataJson){
        let jsonData: UserData = JSON.parse(userDataJson);
        jsonData.profilePicture = profilePicture;
        setUserData(jsonData, "persistent");
        return;
    }
    userDataJson = window.sessionStorage.getItem("userData");
    if(!!userDataJson){
        let jsonData: UserData = JSON.parse(userDataJson);   
        jsonData.profilePicture = profilePicture;
        setUserData(jsonData, "session");
        return;     
    }
} 


export const getUserData = () : UserData => {
    let userDataJson = window.localStorage.getItem("userData");
    if(!!!userDataJson || userDataJson == ""){
        userDataJson = window.sessionStorage.getItem("userData");
    }
    if(!!userDataJson){
        let jsonData: UserData = JSON.parse(userDataJson);
        return jsonData;
    }
    return { name: "", permissions: [], profilePicture: ""};
}

const hasPermission = (userData: UserData, permission: Permission) => {
    return userData.permissions.findIndex(i => i == permission) !== -1;
}

export const currentUserHasPermission = (permission: Permission) => {
    let userData = getUserData();
    return hasPermission(userData, permission)
} 


export const removeUserData = () => {
    window.localStorage.removeItem("userData");
    window.sessionStorage.removeItem("userData");
}

export const forgotPassword = async (request : ForgotPasswordRequest) => {
    try{
        var result = await axios({method: "POST", data: request, url: `${baseUrl}auth/forgotPassword`});
        return { result : 'success'}
    }
    catch(err : any){
        return {result : 'fail'}
    }    
}
